import { render } from "./EditConfirm.vue?vue&type=template&id=5bdb1a54"
import script from "./EditConfirm.vue?vue&type=script&lang=js"
export * from "./EditConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__